// External Dependencies
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';
import { blue500 } from 'material-ui/styles/colors';

const TwitterIcon = props => (
  <SvgIcon
    color="#ffffff"
    hoverColor={blue500}
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.71,9.33C17.64,13.95 14.69,17.11 10.28,17.31C8.46,17.39 7.15,16.81 6,16.08C7.34,16.29 9,15.76 9.9,15C8.58,14.86 7.81,14.19 7.44,13.12C7.82,13.18 8.22,13.16 8.58,13.09C7.39,12.69 6.54,11.95 6.5,10.41C6.83,10.57 7.18,10.71 7.64,10.74C6.75,10.23 6.1,8.38 6.85,7.16C8.17,8.61 9.76,9.79 12.37,9.95C11.71,7.15 15.42,5.63 16.97,7.5C17.63,7.38 18.16,7.14 18.68,6.86C18.47,7.5 18.06,7.97 17.56,8.33C18.1,8.26 18.59,8.13 19,7.92C18.75,8.45 18.19,8.93 17.71,9.33M20,2H4A2,2 0 0,0 2,4V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V4C22,2.89 21.1,2 20,2Z" />
  </SvgIcon>
);

export default TwitterIcon;



/** WEBPACK FOOTER **
 ** ./src/shared/icons/twitter-box.js
 **/